import React from 'react';
import './StatCard.css'

const StatCard = (props) => {
    return ( 
        <div className='StatCard'>
            <p className='SCardLabel'>
                {props.SCardLabel}
            </p>

            <p className='SCardValue'>
                {props.SCardValue}
            </p>

            <img className='SCardIcon' src={props.SCardIcon} alt="" />
        </div>
     );
}
 
export default StatCard
